/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';

@Injectable()
export class UsersApi {
  private readonly apiController: string = 'users';
  private readonly apiControllerCustomer: string = 'customers';

  constructor(private api: HttpService) { }

  getAllUsersAdmin(): Observable<any> {
    return this.api.getAdmin(`${this.apiController}/all/list`)
      .pipe(map(data => {
        return data;
      }));
  }

  getCurrentAdmin(): Observable<any> {
    return this.api.getAdmin(`${this.apiController}/current`)
      .pipe(map(data => {
        // const picture = `${this.api.apiUrl}/${this.apiController}/${data.id}/photo`;
        return { ...data, /*picture*/ };
      }));
  }

  getAdmin(id: number): Observable<any> {
    return this.api.getAdmin(`${this.apiController}/${id}`)
      .pipe(map(data => {
        // const picture = `${this.api.apiUrl}/${this.apiController}/${data.id}/photo`;
        return { ...data, /*picture*/ };
      }));
  }

  deleteAdmin(id: number): Observable<boolean> {
    return this.api.deleteAdmin(`${this.apiController}/${id}`);
  }

  addAdmin(item: any): Observable<any> {
    return this.api.postAdmin(this.apiController, item);
  }

  updateCurrentAdmin(item: any): Observable<any> {
    return this.api.putAdmin(`${this.apiController}/current`, item);
  }

  updateAdmin(item: any): Observable<any> {
    return this.api.putAdmin(`${this.apiController}/${item.id}`, item);
  }

  /**
   * 
   * Customer users from Client App
   * 
   */

  getAllUsersApp(): Observable<any> {
    return this.api.getApp(`${this.apiControllerCustomer}/all`)
      .pipe(map(data => {
        return data;
      }));
  }

  getCurrentApp(): Observable<any> {
    return this.api.getApp(`${this.apiControllerCustomer}/current`)
      .pipe(map(data => {
        // const picture = `${this.api.apiUrl}/${this.apiController}/${data.id}/photo`;
        return { ...data, /*picture*/ };
      }));
  }

  getApp(id: number): Observable<any> {
    return this.api.getApp(`${this.apiControllerCustomer}/${id}`)
      .pipe(map(data => {
        // const picture = `${this.api.apiUrl}/${this.apiController}/${data.id}/photo`;
        return { ...data, /*picture*/ };
      }));
  }

  deleteApp(id: number): Observable<boolean> {
    return this.api.deleteApp(`${this.apiControllerCustomer}/${id}`);
  }

  addApp(item: any): Observable<any> {
    return this.api.postApp(this.apiControllerCustomer, item);
  }

  updateCurrentApp(item: any): Observable<any> {
    return this.api.putApp(`${this.apiControllerCustomer}/current`, item);
  }

  updateApp(item: any): Observable<any> {
    return this.api.putApp(`${this.apiControllerCustomer}/${item.id}`, item);
  }
}
